import { render, staticRenderFns } from "./comingsoon.vue?vue&type=template&id=3f71ecb3&scoped=true"
import script from "./comingsoon.vue?vue&type=script&lang=js"
export * from "./comingsoon.vue?vue&type=script&lang=js"
import style0 from "./comingsoon.vue?vue&type=style&index=0&id=3f71ecb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71ecb3",
  null
  
)

export default component.exports